import axios from 'axios';
import { getNikshayHeaders } from '../utils/getHeaders';

const nikshayClient = axios.create({
  baseURL: 'nodeapi',
  // timeout: 30000,
});

nikshayClient.interceptors.request.use(
  (config) => {
    const headers = getNikshayHeaders();
    Object.assign(config.headers, headers);

    return config;
  },
  (error) => Promise.reject(error)
);

export const nikshayAPI = {
  registerPatient: async (username, data) =>
    (
      await nikshayClient.post(
        `/nikshay/nikshay-registration`,
        data,
        {
          params: { username }
        }
      )
    ).data,
  getPatients: async (id) => (await nikshayClient.get(`/nikshay/get-patient/${id}`)).data,
  updateTreatment: async (id, data) => (await nikshayClient.put(`/nikshay/treatment/${id}`, data)).data,
  checkDuplicates: async (data) => (await nikshayClient.post('/nikshay/get-duplicates-nikshay', data)).data,
  getState: async () => (await nikshayClient.get('/nikshay/nikshay-state')).data,
  getDistrict: async (stateId) => (await nikshayClient.get(`/nikshay/district/${stateId}`)).data,
  getUserDetailsWithHierarchy: async (id) => (await nikshayClient.get(`/nikshay/get-user-details-with-hierarchy/${id}`)).data,
  getTuList: async (districtHierarchyId) => (await nikshayClient.get(`/nikshay/tu-list?districtHierarchyId=${districtHierarchyId}`)).data,
  getFacilities: async (tuId) => (await nikshayClient.get(`/nikshay/get-facilities?Type=Public&tuHierarchyId=${tuId}`)).data,
  getVillages: async (facilityId) => (await nikshayClient.get(`/nikshay/get-villages?Type=Public&facilityHeriarcyId=${facilityId}`)).data,
  getInformant: async (hierarchyId) => (await nikshayClient.get(`/nikshay/get-informant-details?hierarchyId=${hierarchyId}`)).data,
  // addTest: async (data) => (await nikshayClient.post('/nikshay/add-test?username=${username}', data)).data
  getHierarchyChildren: async (parentId) => (await nikshayClient.get(`/nikshay/get-hierarchy-children/${parentId}`)).data,
  getHierarchyFilters: async (id, testType) => (await nikshayClient.get(`/nikshay/hierarchy-filters`, { params: { Id: id, testType } })).data,
  addTest: async (data) =>( await nikshayClient.post( `/nikshay/add-test`,data)).data,
  // addTest: data =>console.log(data),
  getTest: async (patientId) =>  (await nikshayClient.get(`/nikshay/get-test`, {params: { patientId }})).data,
  getDataAgainByRefId: async (refId) => (await nikshayClient.get(`/nikshay/get-data-again-refID/${refId}`)).data,
  getPatientsByHealthId: async (data) => (await nikshayClient.post(`/nikshay/search-by-abha-id`,data)).data,
  getEpisodeDetails: async (episodeId) => (await nikshayClient.get(`/nikshay/user/episode`, { params: { episodeId } })).data,
  getTreatmentDetails: async (episodeId) => (await nikshayClient.get(`/nikshay/user/treatment-details/${episodeId}`)).data,
  startTreatment: async (id, data) => (await nikshayClient.post(`/nikshay/start-treatment/${id}`, data)).data,
  getStartTreatmentCondition: async (id) => (await nikshayClient.get('/nikshay/user/start-treatment-condition', { params: { id } })).data,
  getFormExistingData: async (id) => (await nikshayClient.get('/nikshay/user/form-existing-data', { params: { id } })).data,
  getTypeOfTreatment: async (id) => (await nikshayClient.get('/nikshay/user/type-of-treatment', { params: { id } })).data,
  getAdherenceTechnology: async (hierarchyMapCurrent) => (await nikshayClient.get('/nikshay/user/adherence-technology', { params: { hierarchyMapCurrent } })).data,
  getRegimenV2: async (typeOfTreatment) => (await nikshayClient.get('/nikshay/user/regimen-v2', { params: { typeOfTreatment } })).data
};